"use strict";

/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

// FIXME: Use `import` once https://github.com/babel/babel/issues/2877 is fixed
// or the workaround therein is added to `@novivia/babel`.
module.exports = require("./lib/raven");


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@novivia/logger/frontend.js
// module id = 896
// module chunks = 6